import { CollapseProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: CollapseProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as CollapseProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      label: 'Simple text',
      children: 'Lorem perferendis sapiente quas facilis!',
      open: true,
    } as CollapseProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
